module.exports = __webpack_public_path__ + "img/SES_243250501.08febceb.jpg";